<script setup lang="ts">
import { Badge } from '~ds/components/ui/badge';
import { Heading, Text } from '~ds/components/ui/typography';

import type { ArticleTemplateKeepReading } from '~/components/Article/articleTemplates';

interface Props {
  articles: ArticleTemplateKeepReading[];
}

defineProps<Props>();
</script>

<template>
  <section v-if="articles.length > 0">
    <Text size="sm" class="mb-4 font-semibold uppercase tracking-wide">
      {{ $t('unified.articles.keepReading') }}
    </Text>
    <div class="grid gap-4 sm:grid-cols-3">
      <NuxtLink
        v-for="item in articles"
        :key="item.id"
        :to="item.to"
        class="rounded-2xl bg-white p-5"
      >
        <Badge tone="lime" class="mb-3 uppercase">
          {{ $t('unified.articles.badge') }}
        </Badge>
        <Heading size="xs" as="h3">
          {{ item.name }}
        </Heading>
      </NuxtLink>
    </div>
  </section>
</template>
